import type React from 'react';
import styled from 'styled-components';
import { useInjection } from 'inversify-react';
import type { AppController } from '@/engine/app/App.controller';
import { TYPES } from '@/engine/ioc';
import { observer } from 'mobx-react';

export const CineloopHover: React.FC = observer(() => {
  const appController = useInjection<AppController>(TYPES.AppController);

  return (
    <Container data-testid={'cineloop-hover'} isCinelooping={appController.isCineloopActive} />
  );
});

const Container = styled('div').withConfig({
  shouldForwardProp: (prop) => prop !== 'isCinelooping',
})<{ isCinelooping: boolean }>`
  position: absolute;
  z-index: 997;
  background-color: rgba(255, 255, 255, 0.5);
  display: ${(props): string => (props.isCinelooping ? 'block' : 'none')};
  width: 100%;
  height: 100%;
  transition: 0.5s ease-in-out;
`;
